import React from 'react';
import { ModuleConfig } from '../../types/ModuleConfig';
import { getColor } from '../../brandConfig';

const SovereigntyDashboard = React.lazy(() => import('./SovereigntyDashboard'));
const SovereigntyClientPage = React.lazy(() => import('./SovereigntyClientPage'));

const sovereigntyModuleConfig: ModuleConfig = {
  id: 'sovereignty', name: 'Client Sovereignty Journey',
  description: 'Track spend, learning, access, hardware and handover without changing agreements or permissions',
  version: '0.1.0', enabled: true, category: 'business', order: 15, icon: '🧭', color: getColor('primaryBlue'),
  routes: [
    { path: '/sovereignty', component: SovereigntyDashboard, permissionLevel: 'view', useLayout: true, layoutOptions: { maxW: 'container.xl', py: 6 } },
    { path: '/sovereignty/my-progress', component: SovereigntyClientPage, permissions: [], useLayout: true, layoutOptions: { maxW: 'container.lg', py: 6 } },
  ],
  navigation: [{ label: 'Journeys', path: '/sovereignty', icon: '🧭', permissionLevel: 'view' }],
  permissions: { view: [], create: [], edit: [], delete: [] },
};
export default sovereigntyModuleConfig;
